import Api from '../index';
import { endpoints } from '../endpoints';

export default class TransApi extends Api {
    common(data) {
        console.log('ddddd', data)
        let url = this.buildUrl(endpoints.trans.common, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    commonNew(data) {
        console.log('ddddd', data)
        let url = this.buildUrl(endpoints.trans.commonNew, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    commonGet(data) {
        console.log("commonGetdata->", data)
        let url = this.buildUrl(endpoints.trans.commonGet, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    fundDetail(data) {
        let url = this.buildUrl(endpoints.preLogin.FundCategory, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    getSIPScheme(data) {
        let url = this.buildUrl(endpoints.extra.GetSchemeDetForSIPDashboard, "full")
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    getSchemeName(data) {
        let url = this.buildUrl(endpoints.extra.getSchemeName, "full")
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }
    checkCookies(data) {
        let url = this.buildUrl(endpoints.checkCookies, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response);
    }
    razorpayOrderGeneration(data) {
        let url = this.buildUrl(endpoints.quickbuy.razorpayOrderGeneration, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }
    razorpayOrderGeneration2(data) {
        let url = this.buildUrl(endpoints.quickbuy2.razorpayOrderGeneration, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    razorpaySaveOrder(data) {
        let url = this.buildUrl(endpoints.quickbuy.razorpaySaveOrder, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    GetPGConfirmationdata(data) {
        let url = this.buildUrl(endpoints.quickbuy.GetPGConfirmationdata, "full")
        return this.fetch(url, "POST", JSON.stringify(data)).then(response => response)
    }

    CategoryNew(data) {
        // console.log("In generateOtp", data)
        let url = this.buildUrl(endpoints.preLogin.FundCategoryNew, 'full')
        return this.fetchNormal(url, "POST", JSON.stringify(data)).then(response => response);
    }

    ValidatePIN(pincode) {
        let url = this.buildUrl(endpoints.preLogin.ValidatePIN, 'full')
        const payload = { pincode: pincode };
        return this.fetchNormal(url, "POST", JSON.stringify(payload)).then(response => response);
    }
}
